// Local mirror of playback positions so an offline listen resumes where it
// stopped, and the server catches up when the app is back online.
import { dbGet, dbPut, dbGetAll } from './db';

export async function getLocalPosition(bookId) {
  try { return await dbGet('positions', String(bookId)); } catch (e) { return null; }
}

export async function saveLocalPosition(bookId, updates, { pending = false } = {}) {
  try {
    const current = (await dbGet('positions', String(bookId))) || { bookId: String(bookId) };
    const next = {
      ...current,
      ...updates,
      updatedAt: Date.now(),
      pending: pending || Boolean(current.pending)
    };
    await dbPut('positions', next);
    return next;
  } catch (e) {
    return null;
  }
}

export async function markSynced(bookId) {
  try {
    const current = await dbGet('positions', String(bookId));
    if (current && current.pending) await dbPut('positions', { ...current, pending: false });
  } catch (e) { /* best effort */ }
}

/** Push positions saved while offline to the server. Returns how many synced. */
export async function flushPendingPositions(wasabiService) {
  let all = [];
  try { all = await dbGetAll('positions'); } catch (e) { return 0; }
  let flushed = 0;
  for (const entry of all) {
    if (!entry.pending) continue;
    try {
      if (entry.lastChapterId) {
        await wasabiService.updateChapterPlaybackState(entry.bookId, entry.lastChapterId, {
          lastPlayedPosition: Number(entry.lastPlayedPosition || 0)
        });
      }
      await wasabiService.updateAudiobookPlaybackState(entry.bookId, {
        lastChapterId: entry.lastChapterId,
        lastPlayedPosition: Number(entry.lastPlayedPosition || 0),
        ...(entry.isComplete ? { isComplete: true } : {})
      });
      await markSynced(entry.bookId);
      flushed += 1;
    } catch (e) {
      // Still offline or a server error: keep it pending for the next try.
    }
  }
  return flushed;
}
